import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'
import { redirectToLogin } from '@/middleware/authMiddleware'

export const entitiesApi = {
    async getList() {
        try {
            let { Data } = await $axios.get('/Login/EntitiesList/')
            return Data
        } catch (e) {
            redirectToLogin()
            parseCatch(e, false, 'Entities List')
        }
    }
}
